import { Translate } from 'react-redux-i18n'
import { Element } from '../../common/html/element'
import { formatText } from '../../helpers/value'
import classes from '../index.module.scss'

const ItemInformation = ({ title, value }) => {
  return (
    <div className={`dFlex ${classes.itemData}`}>
      <div className={classes.column1} />
      <Element className="dFlex gap1">
        <div className={`fw600 ${classes.widthTitle}`}>
          <Translate value={title} />:
        </div>
        <div>{formatText(value)}</div>
      </Element>
    </div>
  )
}

export default ItemInformation
